// Typing.js
import React, { useEffect, useState } from "react";
import { TypeAnimation } from "react-type-animation";

const TEST_MSG = [
  '질문을 이해하기 위해 노력하고 있습니다. 잠시만 기다려 주세요.',
  '입력하신 내용을 이해하고 있어요. 조금만 더 기다려 주세요.',
  '과학동아AiR에게 구체적으로 질문하시면 더욱 정확한 답변을 얻을 수 있어요.',
  '답변을 기다리다가 멈추고 싶다면 "답변 중지" 버튼을 눌러 주세요.',
  '답변 내용이 마음에 드시면 \"좋아요\" 버튼을 눌러 주세요.'
]
const getRandomMessages = () => {
  const messages = [];
  const array = new Uint32Array(21);
  crypto.getRandomValues(array);
  for (let i = 0; i < 21; i++) {
    const randomIndex = array[i] % TEST_MSG.length;
    messages.push(TEST_MSG[randomIndex], 1000);
  }
  return messages;
};

const Typing = ({ onTypingEnd, infinite }) => {

  const [messages, setMessages] = useState(getRandomMessages);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setMessages(getRandomMessages);
    }, 6000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <TypeAnimation
      wrapper="p"
      repeat={infinite ? Infinity : null}
      sequence={messages}
      speed={80}
      // deletionSpeed={50}
      style={{
        lineHeight: '2rem',
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
      }}
      className="chat-ans__txt min-h-8"
      cursor={false}
      onComplete={onTypingEnd}
      omitDeletionAnimation={true}
    />
  );
};

export default Typing;
